import React from 'react';
import PropTypes from 'prop-types';

export default function IcMap({ className }) {
  return (
    <svg className={className} fill="none" height="14" viewBox="0 0 16 14" width="16" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.005 13.797L6 11.572V0.239674L10.0004 3.03998L10.005 13.797ZM11.005 13.7801L15.7572 10.9287C15.9079 10.8384 16 10.6756 16 10.5V0.500001C16 0.313564 15.8963 0.142611 15.7309 0.0565121C15.5655 -0.0295868 15.366 -0.0165295 15.2133 0.0903855L11.0004 3.03937L11.005 13.7801ZM0.213269 3.59039L5 0.239674V11.572L0.742821 13.9371C0.587956 14.0231 0.399125 14.0208 0.246436 13.9309C0.0937472 13.8411 0 13.6772 0 13.5V4C0 3.83684 0.0796055 3.68395 0.213269 3.59039Z" fill="#5E811E"/>
    </svg>
  );}

IcMap.propTypes = {
  className: PropTypes.string
};

